import { Component } from "react";

export default class MiniCupErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("MiniCup tab crashed:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="rounded-xl border border-red-500/40 bg-red-500/10 p-4 text-sm text-red-300" data-testid="minicup-tab-error">
          <p className="font-bold">Something went wrong loading this tab.</p>
          <p className="mt-1 break-words text-xs opacity-80">{String(this.state.error?.message || this.state.error)}</p>
          <button onClick={() => this.setState({ error: null })} className="mt-3 rounded-lg wc-bg-gold px-3 py-1.5 text-xs font-bold text-slate-900" data-testid="minicup-tab-error-retry">Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
